import React, { useState, useEffect, useRef } from 'react';
import ProfileRow from './ProfileRow';
import CanvasItem from './avwapp.chart';
import { fetchData } from './service/avwapp.service';
import { host } from './env';
import StockPopupButton from './StockPopupButton';

type HvcProps = {};

export type Hvc = {
  symbol: string;
  createdAt: string
  volume: number;
  hvcDaily1Yr: number;
  hvcDaily45d: number;

};

const Hvc: React.FC<HvcProps> = ({}) => {
  const [hvcData, setHvcData] = useState<Hvc[]>(
    [],
  );
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    handleHvc();
  }, []);

  const fetchHvcFromApi = async () => {
    try {
      const result = await fetchData(`${host}/latestHvcs`);
      setHvcData(result);
    } catch (err) {
      setError('Failed to get hvc stocks');
      console.log('err', err);
    } finally {
    }
  };

  const handleHvc = async () => {
    fetchHvcFromApi();
  };

  function formatMarketCap(value: number): string {
    if (value >= 1_000_000_000) {
      return (value / 1_000_000_000).toFixed(2) + 'B';
    } else if (value >= 1_000_000) {
      return (value / 1_000_000).toFixed(2) + 'M';
    } else if (value >= 1_000) {
      return (value / 1_000).toFixed(2) + 'K';
    } else {
      return value.toString();
    }
  }

  function formatPercentage(decimal: number): string {
    return (decimal * 100).toFixed(1) + '%';
  }

  return (
    <div>
      <h3 className="avwapp-subtitle">High Volume Candle results</h3>
      <table className="qualityStocks">
        <thead>
          <tr>
            <td>Symbol</td>
            <td>Created At</td>
            <td>HVC 1yr</td>
            <td>HVC 45 days</td>
          </tr>
        </thead>

        {hvcData.map((item: Hvc) => (
          <tr>
            <td>{<StockPopupButton symbol={item.symbol} />}</td>
            <td>{item.createdAt} </td>
            <td className={item.hvcDaily1Yr ? "green" : "orange"}>
              {item.hvcDaily1Yr.toString()}</td>
              <td className={item.hvcDaily45d ? "green" : "orange"}>
              {item.hvcDaily45d.toString()}</td>
   
          </tr>
        ))}
      </table>
    </div>
  );
};

export default Hvc;
